<template>

    <div class="qr">

        <img class="code" src="/img/landing/qr-code-instant-app.png">

        <div class="line" :class="{'big-line': big}">
            <img src="/img/landing/bugdroid.svg">
            <span>Instant App</span>
        </div>

    </div>

</template>

<script>

export default {

    name: 'q-r-code-instant-app',

    props: {
        big: {
            type: Boolean,
            default: false
        }
    }
}

</script>

<style lang="scss" scoped>

.qr {
    display: flex;
    flex-direction: column;
    align-items: center;

    .code {
        width: 100%;
    }

    .line {
        display: flex;
        align-items: center;
        margin-top: 16px;

        > img {
            width: 16px;
            object-fit: contain;
            margin-right: 5px;
        }

        > span {
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            color: $white;
        }
    }

    .big-line {
        > img {
            width: 32px;
            margin-right: 10px;
        }

        > span {
            font-size: 30px;
        }
    }
}

</style>

